import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { MetricsBar } from '../components/MetricsBar';
import { CaseStudies } from '../components/CaseStudies';
import { ApproachSteps } from '../components/ApproachSteps';
import { Recognition } from '../components/Recognition';
import { EngagementModels } from '../components/EngagementModels';
export function ResultsPage() {
  return <>
      <PageHeader label="Documented Impact" title="Cost reduction, synergy, and portfolio results at enterprise scale" description="More than $220 million in annual reductions across MetLife, Syneos Health, and Parexel — shown as situation, action, and outcome." data-id="element-483" data-mp="1en9vhu10fug3" />
      <MetricsBar data-id="element-484" data-mp="19o7256ue7cny" />
      <CaseStudies showLabel={false} data-id="element-485" data-mp="19nnnbz01h4e5" />
      <ApproachSteps data-id="element-486" data-mp="19qta37l73u6p" />
      <Recognition data-id="element-487" data-mp="3pg4ejvwtrty7" />
      <EngagementModels data-id="element-488" data-mp="3pfl7594swnyf" />
    </>;
}